import { CommonExtension } from '../../../core/index.js';
import 'prosemirror-inputrules';
import { PluginKey } from 'prosemirror-state';
import 'prosemirror-model';
import 'prosemirror-commands';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var clearMark = function(provider) {
    return function() {
        return function(state, dispatch) {
            var selection = state.selection, schema = state.schema, tr = state.tr;
            var $cursor = selection.$cursor;
            var _schema_nodes = schema.nodes, paragraph = _schema_nodes.paragraph, heading = _schema_nodes.heading, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item;
            var marks = schema.marks;
            var excludeMarks = (provider === null || provider === void 0 ? void 0 : provider.excludeMarkNames) || [];
            // 清除光标左右两边的格式
            if ($cursor) {
                var cursor = $cursor.pos;
                var beforeNode = $cursor.nodeBefore;
                var afterNode = $cursor.nodeAfter;
                if (beforeNode) {
                    Object.keys(marks).forEach(function(mark) {
                        if (excludeMarks.indexOf(mark) !== -1) return;
                        tr.removeMark(cursor - beforeNode.nodeSize, cursor, marks[mark]);
                    });
                }
                if (afterNode) {
                    Object.keys(marks).forEach(function(mark) {
                        if (excludeMarks.indexOf(mark) !== -1) return;
                        tr.removeMark(cursor, cursor + afterNode.nodeSize, marks[mark]);
                    });
                }
            }
            // 处于 CellSelection 时可能有多个 range
            selection.ranges.forEach(function(range) {
                var from = range.$from.pos;
                var to = range.$to.pos;
                tr.doc.nodesBetween(from, to, function(node, pos, parent) {
                    if (node.type === heading) {
                        tr.setNodeMarkup(pos, paragraph, node.attrs);
                        // -1 表示当前文本（p）元素的父元素也就是list_item（task_item）元素。
                        if ((parent.type === list_item || parent.type === task_item) && tr.doc.nodeAt(pos - 1)) {
                            tr.setNodeMarkup(pos - 1, null, _objectSpreadProps(_objectSpread({}, parent.attrs), {
                                level: null
                            }));
                        }
                    }
                });
                tr.setBlockType(from, to, schema.nodes.paragraph);
                Object.keys(marks).forEach(function(mark) {
                    if (excludeMarks.indexOf(mark) !== -1) return;
                    tr.removeMark(from, to, marks[mark]);
                });
            });
            dispatch(tr);
            return true;
        };
    };
};

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var isCommonDisabled = function() {
    return function(state) {
        return !canInsertTypes(state);
    };
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ClearExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(ClearExtension, CommonExtension);
    var _super = _createSuper(ClearExtension);
    function ClearExtension() {
        _classCallCheck(this, ClearExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ClearExtension.prototype;
    _proto.commands = function commands(param) {
        var providers = param.providers;
        var clearProvider = providers.get(this.name);
        return {
            clearMark: clearMark(clearProvider),
            isDisabled: isCommonDisabled
        };
    };
    _createClass(ClearExtension, [
        {
            key: "name",
            get: function get() {
                return "clear";
            }
        }
    ]);
    return ClearExtension;
}(CommonExtension);

export { ClearExtension };
//# sourceMappingURL=index.js.map
